import { render } from "./saveKitNameSet.vue?vue&type=template&id=6237363e"
import script from "./saveKitNameSet.vue?vue&type=script&lang=js"
export * from "./saveKitNameSet.vue?vue&type=script&lang=js"

import "./saveKitNameSet.vue?vue&type=style&index=0&id=6237363e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__